import { useIntl } from "react-intl";
import { useIsPunchOut } from "@/hooks/useIsPunchOut";
import styles from "./PunchOutBackButton.module.scss";
import { CtaButton } from "../ctaButton/CtaButton";

export const PunchOutBackButton = () => {
  const intl = useIntl();
  const isPunchOut = useIsPunchOut();

  const navigateToReturnUrl = () => {
    const customBackUrl = process.env.NEXT_PUBLIC_PABLO_RETURN_URL;
    if (customBackUrl != null) {
      window.location.href = customBackUrl;
    }
  };

  return isPunchOut ? (
    <CtaButton
      label={intl.formatMessage({ id: `punchOutBackButton` })}
      isMarineBg={true}
      onClick={() => navigateToReturnUrl()}
      overloadContainerStyle={styles.backButton}
    ></CtaButton>
  ) : null;
};

export default PunchOutBackButton;
